import { render, staticRenderFns } from "./FeedItemMsg.vue?vue&type=template&id=4c8fb2ee&scoped=true&"
import script from "./FeedItemMsg.vue?vue&type=script&lang=js&"
export * from "./FeedItemMsg.vue?vue&type=script&lang=js&"
import style0 from "./FeedItemMsg.vue?vue&type=style&index=0&id=4c8fb2ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fb2ee",
  null
  
)

export default component.exports